import type { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@interstate/components/Box';
import { dealLockHooks } from '@makemydeal/dr-dash-components';
import * as firstPencilActionCreators from '@makemydeal/dr-dash-store/actions/firstPencilActionCreators';
import { logFirstPencilProgramSelected } from '@makemydeal/dr-dash-store/utils/firstPencilTelemetry';
import type { ProgramQuote } from '@makemydeal/dr-dash-types';

import { SelectActionChip } from '../Programs/styles';
import type { FirstPencilProgramsOfferType } from './types';

export type FirstPencilSelectActionColumnBodyProps = {
    value: ProgramQuote & { key?: string };
    index: number;
    offerType: FirstPencilProgramsOfferType;
    isSelected: boolean;
};

export const FirstPencilSelectActionColumnBody: FC<FirstPencilSelectActionColumnBodyProps> = ({
    value,
    index,
    offerType,
    isSelected
}) => {
    const dispatch = useDispatch();
    const isLocked = dealLockHooks.useIsDealLocked();

    const handleClick = () => {
        if (!isSelected) {
            logFirstPencilProgramSelected(offerType, value.lenderLegalName);
            dispatch(firstPencilActionCreators.programSelected(value, offerType));
        }
    };

    return (
        <Box display={'flex'} justifyContent={'center'}>
            <SelectActionChip
                label={isSelected ? 'Selected' : 'Select'}
                data-testid={`first-pencil-select-button-${index}`}
                onClick={handleClick}
                isApplied={isSelected}
                isApplying={false}
                disabled={isLocked}
            />
        </Box>
    );
};
